export default (filter = [[]], value) => filter.map(
	filterVal => filterVal.map(
		f => (typeof f === 'string' ? ({ param: f, value }) : f),
	),
)
